import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard'; // Import Admin
import "@/App.css";

function App() {
  // Add Google Fonts
  useEffect(() => {
    const link = document.createElement('link');
    link.href = "https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;800&family=Manrope:wght@400;500;600&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    
    // Set favicon
    const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
    favicon.type = 'image/png';
    favicon.rel = 'shortcut icon';
    favicon.href = 'https://customer-assets.emergentagent.com/job_ab97cb40-047d-4dfe-8f46-5d5753921605/artifacts/kpt72b31_escudo.png';
    document.head.appendChild(favicon);

    document.title = "SOP RCDM";
    document.documentElement.classList.add('dark'); // Force dark mode
  }, []);

  return (
    <div className="App bg-[#09090B] min-h-screen text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/admin" element={<AdminDashboard />} /> {/* Admin Route */}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
